"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const arrayFieldTemplate_style_1 = __importDefault(require("./arrayFieldTemplate.style"));
class ArrayField extends react_1.default.PureComponent {
    render() {
        const { classes, title, items } = this.props;
        if (!items.length)
            return null;
        return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.text }, { children: title }), void 0),
                items.map((item, i) => (jsx_runtime_1.jsx("div", Object.assign({ className: classes.fieldWrapper, style: { marginBottom: i < items.length - 1 ? '20px' : '' } }, { children: item.children }), item.index)))] }, void 0));
    }
}
exports.ArrayField = ArrayField;
exports.default = react_jss_1.default(arrayFieldTemplate_style_1.default)(ArrayField);
//# sourceMappingURL=index.js.map